<template>
	<div class="pardata_box" v-if="detailList">
		<div class="data_wrap">
			<ul>
				<li v-for="(v, ind) in objdata" :key="ind" :title="v" v-html="v || ''"></li>
				<li>
					<span v-if="type != 800">{{ langtrans().sgjjgg[languageIndex] }}{{ def }}</span>
          			<span v-else>服务经过：{{ def }}</span>
				</li>
			</ul>
		</div>
		<div>
			<ul class="gl" v-if="false">
				<li>关联案件号：</li>
				<li v-for="(item,index) in glData" :key="index" class="blue" :class="{'red':item.status}"  @click="topath(item.id,index)">{{ item.caseNo }}</li>
			</ul>
		</div>
<!--    <jianbao style="margin: 20px 0;"></jianbao> -->
	</div>
</template>

<script>
import langtrans from './js/Parinf.vue.trans.js';
import constants from '@/util/constants.js';
import { getCasedetail, connectedCaseList,listSubRegulators,userlist_regulator } from '@/views/axios/api.js';
import jianbao from '@/components/par/jianbao'

export default {
	data() {
		let that = this;
		return {
      subRegulatorIdName:'',
      name:'',
      		type:'',
			token:JSON.parse(window.localStorage.getItem('data')).data,
			caseid: this.$route.query.caseid || this.$route.query.id || this.$route.query.caseId,
			obj: {},
			objdata: {},
			acc_list: [],
			checkList: [],
			def: '',
			bid: [],
			inf: null,
			usertype: JSON.parse(window.localStorage.getItem('usertype')).data,
			glData: [],
			glDataStatus: false,
      		state:['N/A','待认定','无责','有责']
		};
	},
	components:{
		jianbao
	},
	props: ['detailList'],
	methods: {
		setTxt(str, status) {
			if (constants.setTxt(str, status)) {
				return constants.setTxt(str, status);
			} else {
				return str;
			}
		},
		langtrans() {
			return langtrans;
		},
		getDetail() {
      		if(this.detailList.obj.obj.incidentType == '' ) return
			var data = this.detailList;
    
    
      console.log(data)
			let addr = '',
				country = '',
				city = '',
				exp = '',
				ssbw = '';
        
			if (data.obj.generalLocation) {
				if (!this.setTxt(data.obj.generalLocation.addr, 'zh')) {
					addr = data.obj.generalLocation.addr;
				} else {
					addr = this.languageIndex == 0 ? this.setTxt(data.obj.generalLocation.addr, 'zh') : this.setTxt(data.obj.generalLocation.addr, 'en');
				}
			}
			if (data.obj.caseCountry) {
          		country = this.languageIndex == 0 ? data.obj.caseCountry : data.obj.caseCountryEn;
			}
			if (data.obj.caseCity) {
				if (this.languageIndex == 0) {
					city = data.obj.caseCity;
				} else {
					city = data.obj.caseCityEn;
				}
			}
			if (data.obj.victimList[0].obj.injuredPart) {
				if (!this.setTxt(data.obj.victimList[0].obj.injuredPart, 'zh')) {
					ssbw = data.obj.victimList[0].obj.injuredPart;
				} else {
					ssbw =
						this.languageIndex == 0
							? this.setTxt(data.obj.victimList[0].obj.injuredPart, 'zh')
							: this.setTxt(data.obj.victimList[0].obj.injuredPart, 'en');
				}
			}
			var type = '';
			if (data.obj.obj.accidentType) {
				type = this.languageIndex == 0 ? data.obj.obj.accidentType : data.obj.obj.accidentTypeEn;
			} else {
				type = '无';
			}
			if (this.setTxt(data.obj.obj.incidentDesc, 'zh')) {
				this.def = this.languageIndex == 0 ? this.setTxt(data.obj.obj.incidentDesc, 'zh') : this.setTxt(data.obj.obj.incidentDesc, 'en');
			} else {
				this.def = this.languageIndex == 0 ? '未填写' : 'None';
			}
			this.type = data.obj.obj.incidentType
			if(data.obj.obj.incidentType != 800) {
            	this.objdata = {
					country: this.langtrans().cxdd[this.languageIndex]+country,
					city: this.langtrans().cxdd1[this.languageIndex]+city,
					addr: this.langtrans().cxdd2[this.languageIndex]+addr,
					type: this.langtrans().sglx[this.languageIndex] + type,
					part:this.langtrans().ssbw[this.languageIndex] + ssbw,
					weather:this.langtrans().tqzh[this.languageIndex] + (data.obj.obj.weatherTag || this.langtrans().wm[this.languageIndex]),
					zeren:'保险责任认证：'+ this.state[data.obj.obj.insuranceLiabilityStatus],
					zerenDef:'保险责任描述：' + (data.obj.obj.insuranceLiabilityStatement ? data.obj.obj.insuranceLiabilityStatement : '无'),
					ddd:'&nbsp;'
				};
        if(data.obj.obj.incidentType == 900) {
          console.log(data.obj.obj)
          
          // 解析remark字段中的保障起期
          var guaranteeStartDate = '';
          if (data.obj.obj.remark) {
            try {
              const remarkObj = JSON.parse(data.obj.obj.remark);
              if (remarkObj.guaranteeStartDate) {
                guaranteeStartDate = remarkObj.guaranteeStartDate;
              }
            } catch (e) {
              console.log('解析remark字段失败:', e);
            }
          }
          
          var caseLevel = ''
          if( data.obj.obj.caseLevel == 100) {
            caseLevel = '高度'
          }else if( data.obj.obj.caseLevel == 200) {
            caseLevel = '紧急'
          }else if( data.obj.obj.caseLevel == 300) {
            caseLevel = '一般'
          }else if( data.obj.obj.caseLevel == 1000) {
            caseLevel = '其他'
          }else {
            caseLevel = '无'
          }
          var newContractType = ''
          if( data.obj.obj.newContractType == 1) {
            newContractType = '大包服务'
          }else if( data.obj.obj.newContractType == 2) {
            newContractType = '小包服务'
          }else if( data.obj.obj.newContractType == 3) {
            newContractType = '纯服务'
          }else {
            newContractType = '无'
          }
          this.objdata.type = '案件等级：' + caseLevel
          this.objdata.part = '服务类型：' + newContractType
          this.objdata.weather = '救援需求：' + data.obj.obj.rescueInfo
          this.objdata.zeren = "医疗诊断:" + data.obj.obj.medicalInfo
		  this.objdata.fff = "医院名称:" + data.obj.obj.hospitalName
		  this.objdata.bbb = "病历号:" + data.obj.obj.medicNo
          if(data.obj.obj.subIncidentType == 100) {
            this.objdata.zerenDef = "产品名称:" + data.obj.obj.caseProductName
            // 添加保障起期字段，如果不为空则显示
            if (guaranteeStartDate) {
              this.objdata.ddd = "保障起期:" + guaranteeStartDate;
            }
            // this.objdata.ddd = ''
          }else if(data.obj.obj.subIncidentType == 200 || data.obj.obj.subIncidentType == 300) {
            this.objdata.zerenDef = '无'
            // 添加保障起期字段，如果不为空则显示
            if (guaranteeStartDate) {
              this.objdata.ddd = "保障起期:" + guaranteeStartDate;
            }
             this.objdata.ddd = '无'
          }else if(data.obj.obj.subIncidentType == 400) {
            this.objdata.zerenDef = "产品名称:" + data.obj.obj.caseProductName
            // 添加保障起期字段，如果不为空则显示
            if (guaranteeStartDate) {
              this.objdata.ddd = "保障起期:" + guaranteeStartDate;
            }
           
              this.objdata.aaa = "会员号:" + data.obj.obj.vipNo
             
              this.objdata.ccc = "客户案件号:" + data.obj.obj.orderNo
              this.objdata.mzjyrq = "门诊就医日期:" +constants.time(data.obj.obj.patientTime) 
              this.objdata.zyssqsrq = "住院/手术起始日期:" +constants.time(data.obj.obj.hospitalStartTime) 
              this.objdata.zyssjsrq = "住院/手术结束日期:" +constants.time(data.obj.obj.hospitalEndTime) 
          }
        
          // delete this.objdata.ddd
        }
        	}else {
            	this.objdata = {
                aaa : "",
                bbb : '&nbsp;',
                ccc : '&nbsp;',
                country: this.langtrans().cxdd[this.languageIndex]+country,
                city: this.langtrans().cxdd1[this.languageIndex]+city,
                addr: this.langtrans().cxdd2[this.languageIndex]+addr,
                type:"服务类型：" + type,
                part: '&nbsp;',
                ddd:'&nbsp;'
              };
				if (data.obj.helpOrder && data.obj.helpOrder.extra && JSON.parse(data.obj.helpOrder.extra).caseSrc == 'pingan') {
					this.objdata.part = "卡券号:" + JSON.parse(data.obj.helpOrder.extra).idProfitItem;
					this.objdata.ddd = "卡券名称:" + JSON.parse(data.obj.helpOrder.extra).couponName;
				}
        //   console.log(this.$route.query.subRegulatorIdname)
         if(this.$route.query.subRegulatorId != '' && this.$route.query.subRegulatorId != null && this.$route.query.subRegulatorId != undefined) {
        
         this.objdata.bbb = "小保单号:" + data.obj.obj.miniPolicy
         }else {
          delete this.objdata.aaa
          delete this.objdata.bbb
          delete this.objdata.ccc
         }
         if(data.obj.obj.lastCheckPtsTs != '') {
           this.objdata.fff = "服务商完成时间:" + constants.time(data.obj.obj.instiEndTs)
         } 
         if(this.$route.query.subRegulatorId != '' && this.$route.query.subRegulatorId != null && this.$route.query.subRegulatorId != undefined) {
                userlist_regulator({
                token: JSON.parse(window.localStorage.getItem("data")).data,
                regulatorId: this.$route.query.regulatorId,
              }).then((res) => {
                // this.companies1 = res.data.obj;
                console.log(res);
                console.log(data.obj.obj)
                for(var i = 0; i<res.data.obj.length; i++) {
                  if(res.data.obj[i].id == this.$route.query.subRegulatorId) {
                    this.objdata.aaa = "保险公司子公司:" + res.data.obj[i].name         
                  }
                }
              });
              }
        	}
			this.def;
		},
		getglData() {
     
			var data = {
				token: this.token,
				caseId: this.caseid
			};
			connectedCaseList(data)
			.then(res => {
				console.log(res);
				if (res.data.obj.length == 0) {
					this.glDataStatus = false;
				} else {
					this.glDataStatus = true;
					this.glData = res.data.obj;
					this.glData.forEach(item => {
						item.status=0
					})
				}
			})
			.catch(err => {
				console.log(err);
			});
		},
    	topath(id,ind){
			var name=this.$route.name;
			this.glData.forEach((item,index) => {
				if(index == ind){
				item.status=1
				}else{
				item.status=0
				}
			})
			this.$router.push({
				name,
				query:{
				typeId:this.$route.query.typeId,
				caseid:id
				}
			})
		}
	},
	computed: {
		languageIndex() {
			return this.$store.state.language;
		}
	},
	mounted() {
   
      	this.getDetail();
		var route = this.$route.fullPath;
		var reg = /commonPage/;
		if (!reg.test(route)) {
			this.getglData();
		}
   
     
	},
	watch: {
		languageIndex() {
			this.getDetail();
		},
		'$route.query.caseid'(){
		this.getDetail();
		},
		detailList(){
		this.getDetail()
		}
	}
};
</script>

<style scoped>
a {
	text-decoration: none;
	color: #00abfa;
}
.data_wrap {
	width: 100%;
	box-sizing: border-box;
  font-size: 14px;
}
.data_wrap h3 {
	font-size: 18px;
	color: #333;
	margin: 10px 0;
}
.data_wrap ul {
	width: 100%;
	overflow: hidden;
  border-left: 1px solid #d9ddde;
}
.data_wrap ul li {
	line-height: 40px;
	float: left;
  border-bottom: 1px solid #d9ddde;
  border-right: 1px solid #d9ddde;
  padding: 0 5px;
  width: calc(33.3% - 11px);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.data_wrap ul li:last-child{width: calc(100% - 11px);}
.data_wrap ul li:last-child textarea {
	width: 80%;
	height: 80px;
	border: 0;
	border: 1px solid #d9ddde;
	border-radius: 5px;
	font-size: 15px;
	margin-top: 15px;
}
.data_wrap ul li:last-child span,
.data_wrap ul li:last-child textarea {
	float: left;
}
.data_wrap ul li:last-child span{
      white-space: break-spaces;
    }
.req_box > p {
	margin-top: 15px;
	line-height: 45px;
	text-align: left;
}
.box_req ul li b {
	font-size: 14px;
}
.org_box {
	font-size: 16px;
	box-sizing: border-box;
	padding-left: 15px;
}
.org_box p {
	line-height: 40px;
	color: #333;
}
.acc_box {
	box-sizing: border-box;
	padding: 0 20px;
}
.acc_box > p {
	color: #333;
	line-height: 40px;
	font-size: 15px;
}
.acc_box ul li {
	display: inline-block;
	width: 20%;
	text-align: center;
}
.acc_box ul li p {
	text-align: center;
	line-height: 36px;
	height: 36px;
	font-size: 14px;
}
.acc_box ul li img {
	width: 90px;
	height: 120px;
}
.rescue_box {
	box-sizing: border-box;
	padding: 0 20px;
}
.rescue_box > p {
	line-height: 40px;
	font-size: 14px;
}
.res_div {
	position: relative;
	top: 18px;
}
.res_box {
	position: relative;
	top: 20px;
	font-size: 14px;
	color: #999;
}
.el-checkbox-group {
	position: relative;
	box-sizing: border-box;
	padding: 0 15px;
}
.el-checkbox {
	width: 100%;
	margin-bottom: 20px;
}
.el-checkbox + .el-checkbox {
	margin-left: 0;
}
.db_div,
.res_div {
	font-size: 14px;
	color: #333;
}
.db_box {
	font-size: 14px;
	color: #333;
	margin-left: 30px;
}
.db_box b {
	color: #ff7200;
	margin-left: 8px;
}
.upbtn_box {
	text-align: center;
	margin-top: 0;
}
.gl {
	overflow: hidden;
	margin-bottom: 20px;
  margin-top: 10px;
}
.gl li {
	float: left;
	margin-right: 10px;
	line-height: 20px;
}
.blue{color: #11b0fa;cursor: pointer;}
.red{color: red;}
</style>



// WEBPACK FOOTER //
// src/views/commonPage/details/Parinf.vue